import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    templateList(params,data) {
        return interfaceAjax({
            url: '/admin/stemplate/list',
            params,
            data
        });
    },
    templateUpdate(data) {
        return interfaceAjax({
            url: '/admin/stemplate/update',
            data
        });
    },
    templateAdd(data) {
        return interfaceAjax({
            url: '/admin/stemplate/add',
            data
        });
    },
    templateDelete(id) {
        return interfaceAjax({
            url: '/admin/stemplate/delete',
            data: {id}
        });
    },
}
